import React from 'react';
import { TextField } from '@mui/material';

interface NumberFieldProps {
  label?: string;
  name: string;
  value: number | string;
  onChange: (value: number | string) => void;
  error?: boolean;
  helperText?: string;
  roundToDecimals?: number;
  min?: number;
  max?: number;
}

const NumberField: React.FC<NumberFieldProps> = ({ 
  label, 
  name, 
  value, 
  onChange, 
  error, 
  helperText,
  roundToDecimals,
  min,
  max
}) => {
  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const numValue = parseFloat(e.target.value);
    if (isNaN(numValue)) return;

    let finalValue = numValue;

    // Apply min/max constraints if defined
    if (min !== undefined && finalValue < min) {
      finalValue = min;
    }
    if (max !== undefined && finalValue > max) {
      finalValue = max;
    }

    // Apply decimal rounding if defined
    if (roundToDecimals !== undefined) {
      finalValue = parseFloat(finalValue.toFixed(roundToDecimals));
    }

    onChange(finalValue.toString());
  };

  return (
    <TextField
      label={label}
      type="number"
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleBlur}
      error={error}
      helperText={helperText}
    />
  );
};

export default NumberField;
